import { Col, Rate, Row } from 'antd'
import { useMemo } from 'react'
import videoConfferenceApi from 'src/api/videoConferenceApi'
import { UsernameByIdLink } from 'src/components/common/other/UsernameById'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { getUser } from 'src/libs/browser'
import { URL_TEMPLATE } from 'src/libs/constant'
import { hasRequiredItem } from 'src/libs/util'
import Image from 'next/image'

const { userRoles } = getUser()

export function RateStudent ({ studentId, teacherId, code, diamond, showDiamond = false }) {
  // const { id } = getSearchQuery()

  const { data } = useGetWithContext(`GET_RATE_CLASS_IN_${code}`, videoConfferenceApi.getSessionRecordDetail, code, { isDisabled: !code })

  const userDetailUrl = useMemo(() => {
    const isRolesNotHaveEditUserInfo = hasRequiredItem(userRoles, ['employee-customer-care-specialist'])
    if (isRolesNotHaveEditUserInfo) {
      return URL_TEMPLATE.SYSTEM_USER_INFORMATION
    }
    return URL_TEMPLATE.MANAGE_USER_DETAIL
  }, [])

  // const { data: dataDiamonds } = useGetData(sessionApi.getMuster, id, { isDisabled: !id })

  // const diamondTutor = useMemo(() => {
  //   if (!dataDiamonds || dataDiamonds?.length === 0) {
  //     return null
  //   }
  //   return dataDiamonds.find(item => item?.lmsStudentId === studentId)?.diamondTutor
  // }, [dataDiamonds])
  if (!studentId) return null

  const { note, rate, cup } = useMemo(() => {
    if (!data) return { rate: '0', note: '' }
    const studentAccountDetail = data.studentAccountDetails?.find(item => item.userClientId === studentId.toString())
    const studentAccountDetailId = studentAccountDetail?.partnerIds?.find(item => item.partner === 'CLASS_IN')?.id
    const teacherNote = (data.classInData?.teacherNotes || {})[studentAccountDetailId] || ''
    const teacherRate = (data.classInData?.teacherRates || {})[studentAccountDetailId] || '0'
    const teacherCup = (data.classInData?.studentCups || {})[studentAccountDetailId] || '0'
    return { note: teacherNote, rate: teacherRate, cup: teacherCup }
  }, [data])
  if (!note && !rate) return null

  return (
    <Col>
      <Row justify='space-between' wrap>
        <Col>
          <UsernameByIdLink useHook={useGetWithContext} userInfoUrl={userDetailUrl} id={teacherId} /><br />
          <Rate disabled allowHalf value={Number(rate)} /><br />
          <div className='d-flex align-items-center mt-1'>
            <Image
              src='/image/muster/cup.png'
              width={17}
              height={17}
              alt='icon'
            />
            <span
              style={{ fontWeight: 500, marginRight: '12px', marginLeft: '3px' }}
            >
              {(cup || 0) > 0 ? String(cup).padStart(2, '0') : '0'}
            </span>
            {showDiamond && (
              <>
                <Image
                  src='/image/muster/diamond.png'
                  width={22}
                  height={20}
                  alt='icon'
                />
                <span
                  style={{ fontWeight: 500, marginLeft: '3px' }}
                >
                  {(diamond || 0) > 0 ? String(diamond).padStart(2, '0') : '0'}
                </span>
              </>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col style={{ whiteSpace: 'pre-wrap' }}>
          {note}
        </Col>
      </Row>
    </Col>
  )
}
